import React from 'react';

interface EntryFormInputType {
    type: string,
    placeholder: string,
    value: string | null,
    errorMessage?: string,
    onChange: (value: string) => void,
    onBlur?: (value: string) => void,
    max?: string,
}

const EntryFormInput: React.FC<EntryFormInputType> = ({type, placeholder, value, errorMessage, onChange, onBlur, max}) => {
    return (
        <div>
            <div className="flex flex-row">
                <input
                    type={type}
                    className="form-input"
                    placeholder={placeholder}
                    value={value ?? ''}
                    onChange={(e) => {onChange(e.target.value)}}
                    onBlur={(e) => {if(onBlur) onBlur(e.target.value)}}
                    max={max}
                />
            </div>
            {errorMessage && <div className="form-error text-red-500 text-sm mt-1">{errorMessage}</div>}
        </div>
    )
}

export default EntryFormInput;
